import { Option } from "@src/lib/ui/InlineEditSingleSelectField";
import { useAvailableLanguages } from "@src/features/contentDetail/hooks/useAvailableLanguages";
import { langCodeToEnglishName } from "@src/features/app/utils/copy";
import { useMemo } from "react";

const useOrderedLanguageChoices = (): Option<Language>[] => {
  const { allLanguages: orderedLanguages } = useAvailableLanguages();
  return useMemo(() => {
    return orderedLanguages.map((lang) => ({
      value: lang,
      label: langCodeToEnglishName(lang) || lang,
    }));
  }, [orderedLanguages]);
};

export default useOrderedLanguageChoices;
